import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { XCircle, CheckCircle } from 'lucide-react';

interface BeforeAfterScenarioProps {
  beforeText: string;
  afterText: string;
}

export const BeforeAfterScenario = ({ beforeText, afterText }: BeforeAfterScenarioProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      {/* Before */}
      <Card className="border-destructive/50 bg-destructive/5">
        <CardHeader>
          <div className="flex items-center gap-3">
            <XCircle className="w-6 h-6 text-destructive" />
            <CardTitle className="text-destructive">Before Rental Manager</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {beforeText}
          </p>
        </CardContent>
      </Card>

      {/* After */}
      <Card className="border-primary bg-primary/5">
        <CardHeader>
          <div className="flex items-center gap-3">
            <CheckCircle className="w-6 h-6 text-primary" />
            <CardTitle className="text-primary">After Rental Manager</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm leading-relaxed">
            {afterText}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
